import React from 'react';

type Props = {
  open: boolean;
  children?: React.ReactNode;
  color?: 'white' | 'gray' | 'dark-gray';
};

function Dimmer({ color = 'white', open, children }: Props) {
  const classes = [
    'sm:rounded-md',
    'absolute',
    'inset-0',
    'flex',
    'justify-center',
    'items-center',
    'opacity-75',
    'z-20',
  ];

  if (color === 'white') {
    classes.push('bg-white');
  } else if (color === 'dark-gray') {
    classes.push('bg-gray-500');
  } else {
    classes.push('bg-gray-100');
  }

  return open ? (
    <div>
      <div className={classes.join(' ')} />
      <div className="absolute inset-0 z-30 flex items-center justify-center">{children}</div>
    </div>
  ) : null;
}

export default Dimmer;
